import Modal from 'shared/components/Modal'
import { isMobile } from 'shared/responsive-helpers'

import styles from './styles.module.scss'

const PixModal = ({ onClose, onCancelClick, onConfirmClick, cancelModalOpen }) => {
    const onCancelBtnLabel = cancelModalOpen ? <T>pix.payment.cancel.btn.label</T> : <T>pix.payment.cancel.btn.label</T>
    const onConfirmBtnLabel = cancelModalOpen ? (
        <T>pix.payment.cancel.modal.ok.button</T>
    ) : (
        <T>pix.payment.confirm.btn.label</T>
    )

    return (
        <Modal
            header={cancelModalOpen ? <T>pix.payment.cancel.modal.title</T> : <T>pix.payment.confirm.modal.title</T>}
            size={isMobile() ? 'small' : 'large'}
            onClose={onClose}
            className={styles.modal}
            buttons={[
                {
                    label: onCancelBtnLabel,
                    onClick: () => onCancelClick(),
                    btnClassName: 'brand-button--outline w-50',
                },
                {
                    label: onConfirmBtnLabel,
                    onClick: () => onConfirmClick(),
                    btnClassName: ' w-50',
                },
            ]}>
            <p>{cancelModalOpen ? <T>pix.payment.cancel.modal.text</T> : <T>pix.payment.confirm.modal.text</T>}</p>
        </Modal>
    )
}

export default PixModal
